import { Flex, Card } from "antd";
import {
  ClockCircleOutlined,
  BellOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "../../../axios-interceptor.js";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useTenantNavigation } from "../../../hooks/useTenantNavigation.js";
import "../../../style/notificationWidget.css"
const Notifications = () => {
  const { t } = useTranslation();
  const { userInfo } = useSelector((state: any) => state.user)
  const [notifications, setnotification] = useState<any>([])
  const navigate = useTenantNavigation()
  const notificationsmock = [
    {
      id: 1,
      icon: <ClockCircleOutlined style={{color: '#FAAD14'}}/>,
      message: "New message received",
      timeAgo: "10m",
      read: false,
      bgColor: "rgba(255, 251, 230, 1)"
    },
    {
      id: 2,
      icon: <BellOutlined  style={{color: '#1677FF'}}/>,
      message: "You have a meeting at 2:00 PM",
      timeAgo: "15m",
      read: false,
      bgColor: "rgba(230, 244, 255, 1)"
    },
    {
      id: 3,
      icon: <CheckOutlined style={{color: '#52C41A'}}/>,
      message: "You have a meeting at 2:00 PM",
      timeAgo: "1h",
      read: true,
      bgColor: "rgba(246, 255, 237, 1)"
    },
    {
      id: 4,
      icon: <ClockCircleOutlined style={{color: '#FAAD14'}}/>,
      message: "You have a meeting at 2:00 PM",
      timeAgo: "2h",
      read: true,
      bgColor: "rgba(255, 251, 230, 1)"
    },
    // Add more notifications as needed
  ];

  useEffect(()=>{
    if(userInfo && userInfo.userId){
      let notificationApi =  `${process.env.REACT_APP_BACKEND_API}/userNotifications`
      axios.get(notificationApi,{headers:{  userId: userInfo.userId}}).then(res => {
        let sortedData = res.data ? res.data.sort((a:any, b:any) => {
          let dif:any = new Date(b.createdOn) > new Date(a.createdOn)
          if (dif){
          return 1;
          } else {
          return -1;
          }
        } ) : []
        setnotification(sortedData)
      })
    }
  },[userInfo])

  return (
    <Card
    className="admin-notification"
      style={{ }}
      title={
        <Flex justify="space-between" align="center" style={{paddingTop:'0',marginTop:'0'}}>
          <div className="section-title">{t("Notifications")}</div>
          <p style={{ color: '#1677ff', fontWeight: 'var(--theme-text-weight1)', fontSize: "var(--theme-text-h5", lineHeight: "22px" }}>{t("Mark all as read")}</p>
        </Flex>
        // <div style={{ height: "50px", display: "table", width: "100%" }}>
        //   <Flex
        //     gap={0}
        //     style={{
        //       height: "50px",
        //       paddingBottom: "20px",
        //       display: "table-row",
        //     }}
        //     justify="space-between"
        //   >
        //     <Title
        //       level={5}
        //       style={{
        //         marginBottom: 0,
        //         display: "table-cell",
        //         verticalAlign: "middle",
        //       }}
        //     >
        //       Notifications
        //     </Title>
        //     <Paragraph
        //       style={{
        //         fontSize: "12px",
        //         color: "#1677FF",
        //         display: "table-cell",
        //         verticalAlign: "middle",
        //         textAlign: "right",
        //       }}
        //     >
        //       Mark as read
        //     </Paragraph>
        //   </Flex>
        // </div>
      }
    >
      <div style={{height: "329px", overflowY:"auto" }}>
      {
        notifications.map((notification:any) => (
          <Flex className="notification-item" justify='space-between' align='center' style={{padding:'8px', minHeight: "46px", borderBottom: "1px solid #f0f0f0", cursor:notification.redirectUrl ? "pointer":"default"}} onClick={()=> navigate(notification.redirectUrl)}>
            <Flex justify='flex-start' align='center' style={{width:'90%'}} gap={6}>
              {/* <ClockCircleOutlined /> */}
              <span className="step-circle" style={{backgroundColor: notification.bgColor, minWidth: 24}}>{notification.icon} </span>
              <p style={{margin: "0"}} className="text-regular">{ notification.subject}</p>
            </Flex>
            <div className="notification-time" style={{color:"grey", marginLeft: 10}}>
              { !notification.read &&  <span className="unread-dot"></span> }
              <div style={{display:"flex", flexDirection:"column", textAlign:"right"}}>
              <small style={{whiteSpace:'nowrap'}}>{dayjs(notification.updatedOn).format("YYYY/MM/DD")}</small>
              <small style={{whiteSpace:'nowrap'}}>{dayjs(notification.updatedOn).format("h:m a")}</small>
              </div>
            </div>
          </Flex>
        ))
      }
      </div>
     


      {/* <List
        size="small"
        dataSource={notifications}
        renderItem={(item) => (
          
          <List.Item
            style={{  borderBottom: "1px solid #f0f0f0" }}
          >
            <List.Item.Meta
              avatar={<ClockCircleOutlined />}
              title={
                <Text style={{ fontSize: "13px"}}>
                  {item.message}
                </Text>
              }
            />
            <Text type="secondary" style={{ fontSize: "11px" }}>
              {item.timeAgo}
            </Text>
          </List.Item>
        )}
      /> */}
    </Card>
  );
};

export default Notifications;
